import { secureFetch } from "./authService";
import {API_BASE_URL, PAGINATION_DEFAULT_LIMIT} from "./constants";

export function getCalls(query) {
    let url = API_BASE_URL + '/trade/call?';

    if (query) {
        const {page = 0, filters, limit = PAGINATION_DEFAULT_LIMIT, retailerCompanyId, sorting, status} = query;

        if (limit) {
            url = url + `&limit=${limit}`;
        }

        if (page || page === 0) {
            url = url + `&page=${page}`;
        }

        if (retailerCompanyId) {
            url = url + `&retailerCompanyId=${retailerCompanyId}`;
        }

        if (filters && filters.length) {
            filters.forEach(filter => {
                if (filter.value) {
                    url = url + `&${filter.name}=${filter.value}`;
                }
            });
        }

        if (sorting) {
            url = url + `&sortField=${sorting.id}&sort=${sorting.desc ? 'ASC' : 'DESC'}`;
        }

        if (status) {
            url = url + `&status=${status}`;
        }

    }
    return secureFetch(url, {
        method: 'GET'
    });
}

export function updateCall(query) {
    const call = {
        status: query.status,
        employeeRewardPercent: query.employeeRewardPercent
    };
    return secureFetch(API_BASE_URL + '/trade/call/' + query.id, {
        method: 'PUT',
        body: JSON.stringify(call)
    });
}


// WEBPACK FOOTER //
// ./src/helpers/callsService.js